import axios from 'axios'
import {host} from '../configuraciones'

//constantes
const dataInicial = {
    estados : {},
    municipios : {},
    codigosPostales : {},
    colonias: {}
}

//types
const OBTENER_ESTADOS_EXITO = 'OBTENER_ESTADOS_EXITO'
const OBTENER_MUNICIPIOS_EXITOS = 'OBTENER_MUNICIPIOS_EXITOS'
const OBTENER_CODIGOS_POSTALES_EXITO = 'OBTENER_CODIGOS_POSTALES_EXITO' 
const OBTENER_COLONIAS_EXITO = 'OBTENER_COLONIAS_EXITO'

//reducers
export default function UbicacionApiReducer(state = dataInicial, action) {
    switch (action.type) {
        case OBTENER_ESTADOS_EXITO:
            return {...state, estados: action.payload}
        case OBTENER_MUNICIPIOS_EXITOS:
            return {...state, municipios: action.payload}
        case OBTENER_CODIGOS_POSTALES_EXITO:
            return {...state, codigosPostales: action.payload}
        case OBTENER_COLONIAS_EXITO:
            return {...state, colonias: action.payload}
        default:
            return state
    }
}

//actions
export const obtenerColonias = (cp) => async(dispatch) => {
    try {
        const coloniasResult = await axios.get(`https://apisgratis.com/cp/colonias/cp/?valor=${cp}`)
        dispatch({
            type: OBTENER_COLONIAS_EXITO,
            payload: coloniasResult
        })
    } catch (error) {
        console.log(error);
    }
}

export const obtenerCPs = (municipio) => async(dispatch) => {
    try {
        const cpsResult = await axios.get(`https://apisgratis.com/cp/cp/ciudad/?valor=${municipio}`)
        dispatch({
            type: OBTENER_CODIGOS_POSTALES_EXITO,
            payload: cpsResult
        })
    } catch (error) {
        console.log(error);
    }
}

export const obtenerMunicipios = (estado) => async(dispatch) => {
    try {

        const municipiosResult = await axios.get(`https://apisgratis.com/cp/ciudades/?estado=${estado}`)

        dispatch({
            type: OBTENER_MUNICIPIOS_EXITOS,
            payload: municipiosResult
        })
    } catch (error) {
        console.log(error);
    }
}

export const obtenerEstados = () => async(dispatch) => {
    try {

        axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
        const estadosResult = await axios.get('https://apisgratis.com/cp/entidades/',{
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json'
            }
        })

        dispatch({
            type: OBTENER_ESTADOS_EXITO,
            payload: estadosResult
        })
    } catch (error) {
        console.log(error);
    }
}